"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/radio/radio-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_UCZW3OGHcjs.CompositeContextProvider],
  [_UCZW3OGHcjs.CompositeScopedContextProvider]
);
var useRadioContext = ctx.useContext;
var useRadioScopedContext = ctx.useScopedContext;
var useRadioProviderContext = ctx.useProviderContext;
var RadioContextProvider = ctx.ContextProvider;
var RadioScopedContextProvider = ctx.ScopedContextProvider;







exports.useRadioContext = useRadioContext; exports.useRadioScopedContext = useRadioScopedContext; exports.useRadioProviderContext = useRadioProviderContext; exports.RadioContextProvider = RadioContextProvider; exports.RadioScopedContextProvider = RadioScopedContextProvider;
